<div class="register">
  @if (!registrationComplete()) {
    <app-window>
      <span title>{{ 'features.register.title' | translate }}</span>
      <form body class="register__form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="register__title">
          <h2>{{ 'shared.header.users.register' | translate }}</h2>
        </div>
        <div class="register__input">
          <label class="register__input-label register__input-label--required" for="email">
            {{ 'features.register.fields.email' | translate }}
          </label>
          <input
            id="email"
            name="email"
            type="email"
            autocomplete="email"
            formControlName="email"
            [placeholder]="'features.register.placeholders.email' | translate"
            [class.error]="hasError('email')" />
          <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'email' }" />
        </div>

        <div class="register__input">
          <label class="register__input-label register__input-label--required" for="name">
            {{ 'features.register.fields.fullName' | translate }}
          </label>
          <input
            id="name"
            name="name"
            type="text"
            autocomplete="name"
            formControlName="name"
            [placeholder]="'features.register.placeholders.fullName' | translate"
            [class.error]="hasError('name')" />
          <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'name' }" />
        </div>

        <div class="register__input">
          <label class="register__input-label register__input-label--required" for="birthday">
            {{ 'features.register.fields.birthday' | translate }}
          </label>
          <input
            id="birthday"
            name="birthday"
            type="date"
            autocomplete="bday"
            formControlName="birthday"
            [min]="getMinBirthdate()"
            [max]="getTodayDate()"
            [class.error]="hasError('birthday')" />
          <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'birthday' }" />
        </div>

        <div class="register__input">
          <label class="register__input-label register__input-label--required" for="nickname">
            {{ 'features.register.fields.nickname' | translate }}
          </label>
          <input
            id="nickname"
            name="nickname"
            type="text"
            autocomplete="username"
            formControlName="nickname"
            maxlength="20"
            [placeholder]="'features.register.placeholders.nickname' | translate"
            [class.error]="hasError('nickname')" />
          <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'nickname' }" />
        </div>

        <div class="register__input">
          <label class="register__input-label register__input-label--required" for="password">
            {{ 'features.register.fields.password' | translate }}
          </label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="••••••••"
            autocomplete="new-password"
            formControlName="password"
            [class.error]="hasError('password')" />
          <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'password' }" />
        </div>

        <div class="register__input">
          <label class="register__input-label register__input-label--required" for="repeat-password">
            {{ 'features.register.fields.repeatPassword' | translate }}
          </label>
          <input
            id="repeat-password"
            name="repeat-password"
            type="password"
            placeholder="••••••••"
            formControlName="repeat_password"
            [class.error]="hasError('repeat_password') || passwordMismatch" />
          <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'repeat_password' }" />
          @if (passwordMismatch) {
            <div class="register__error-message">{{ 'features.register.errors.passwordsDontMatch' | translate }}</div>
          }
        </div>

        <div class="register__input">
          <label class="register__input-label register__input-label--required" for="preferredLanguage">
            {{ 'features.register.fields.preferredLanguage' | translate }}
          </label>

          <select
            id="language"
            name="language"
            formControlName="language"
            [class.error]="hasError('preferredLanguage')"
            aria-describedby="preferredLanguageDisclaimer">
            <option value="" disabled selected>
              {{ 'features.register.placeholders.preferredLanguage' | translate }}
            </option>
            @for (lang of preferredLanguages; track $index) {
              <option [value]="lang.code">
                {{ lang.label }}
              </option>
            }
          </select>

          <p id="preferredLanguageDisclaimer" class="register__input-disclaimer">
            ({{ 'features.register.disclaimers.preferredLanguage' | translate }})
          </p>

          <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'language' }" />
        </div>

        <div class="register__terms">
          <label class="checkbox-label">
            <input class="register__terms-input-checkbox" type="checkbox" formControlName="acceptedTerms" required />
            <span [innerHtml]="'features.register.checks.acceptTermsAndConditions' | translate"></span>
          </label>
        </div>

        <div class="register__terms">
          <label class="checkbox-label">
            <input class="register__terms-input-checkbox" type="checkbox" formControlName="acceptedPrivacy" required />
            <span [innerHtml]="'features.register.checks.acceptPrivacyPolicy' | translate"></span>
          </label>
        </div>

        <div class="register__buttons">
          <button class="main-button" type="submit" [disabled]="form.invalid || form.pending">
            <span>{{ 'features.register.button.' + (form.pending ? 'inProgress' : 'submit') | translate }}</span>
          </button>
        </div>

        @if (apiErrorMessage()) {
          <div class="register__alert" role="alert">
            {{ apiErrorMessage() | translate }}
          </div>
        }

        <div class="register__footer">
          <p [innerHtml]="'features.register.alreadyLogged' | translate"></p>
        </div>
      </form>
    </app-window>
  } @else {
    <app-window>
      <span title>{{ 'features.register.title' | translate }}</span>
      <div body>
        <p>{{ 'features.register.success' | translate }}</p>
      </div>
    </app-window>
  }
</div>

<ng-template #errorTemplate let-field="field">
  @if (hasError(field)) {
    <div class="register__error-message">
      {{ getErrorMessage(field) | translate }}
    </div>
  }
</ng-template>
